// AccessControlHOC.js
import React from "react";
import { Box, Typography } from "@mui/material";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import maintenanceMode from "../../images/forbidden/maintenanceMode.png";

const MaintenancePage = () => {
  return (
    <Box component="div" sx={{ display: "flex" }}>
      <StyledMainBox component="main">
        <Box height={200} />
        <Box height={100} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
          <img src={maintenanceMode} height={500} width={700} />
          <Typography variant="h4" color="#AF3241" sx={{ marginBottom: 2 }}>
            We'll be back soon!
          </Typography>
          <Typography variant="body2" color="#AF3241" sx={{ marginBottom: 2 }}>
            Our site is currently down for maintenance. Your instore screens stay operational. Please check back later.
          </Typography>
        </Box>
      </StyledMainBox>
    </Box>
  );
};

export default MaintenancePage;
